import { useVideoEditorGetCompositionsById } from '@mi-front/api-v2';

/**
 * Fetches composition detail by id from video-editor.
 */
export function useCompositionQuery(compositionId: string) {
  return useVideoEditorGetCompositionsById(compositionId, undefined, {
    query: {
      enabled: !!compositionId,
    },
  });
}
